// Mind2Magic CRM — Auth & Initialization
// Extracted from index.html inline script (Phase 1, Step 4).
// Defines initApp, handleLogout, login handler, session check.
// NOTE: The IIFE, init calls, and theme init remain in the inline script
// because they must run AFTER the state bridge is set up (inline script
// runs after all head-imported modules).

import { store } from './store.js'

// ========== AUTH ==========

function _setupLoginHandler() {
    document.getElementById('loginForm')?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const email = document.getElementById('loginEmail').value;
        const password = document.getElementById('loginPassword').value;
        const errorEl = document.getElementById('loginError');

        if (supabaseDB.isConnected()) {
            errorEl.style.display = 'none';
            const btn = e.target.querySelector('button[type="submit"]');
            btn.textContent = 'Ingresando...';
            btn.disabled = true;

            const { user, error } = await supabaseDB.signIn(email, password);
            if (error) {
                errorEl.textContent = error === 'Invalid login credentials' ? 'Correo o contraseña incorrectos' : error;
                errorEl.style.display = 'block';
                btn.textContent = 'Ingresar';
                btn.disabled = false;
                return;
            }
        }

        document.getElementById('loginScreen').style.display = 'none';
        document.getElementById('app').classList.add('active');
        document.body.classList.add('logged-in');
        await initApp();
        window.scrollTo(0, 0);
        document.querySelector('.main')?.scrollTo(0, 0);
        toast('¡Bienvenido/a a Mind2Magic!', 'success');
    });
}

function showLoadingSkeletons() {
    const ps = document.getElementById('pipelineSkeleton');
    const ds = document.getElementById('dashboardSkeleton');
    if (ps) ps.classList.remove('skeleton-hidden');
    if (ds) ds.classList.remove('skeleton-hidden');
}

function hideLoadingSkeletons() {
    const ps = document.getElementById('pipelineSkeleton');
    const ds = document.getElementById('dashboardSkeleton');
    if (ps) ps.classList.add('skeleton-hidden');
    if (ds) ds.classList.add('skeleton-hidden');
}

async function initApp() {
    showLoadingSkeletons();

    // Load data from Supabase if connected
    const loaded = await loadFromSupabase();
    if (loaded) {
        setupRealtimeSubscriptions();
    }

    hideLoadingSkeletons();

    if (!loaded) toast('Error cargando datos. Intenta recargar la página.', 'error', { persistent: true });

    // Auto-transition leads based on travel dates
    if (loaded) {
        try {
            const changes = await window.runAutoTransitions();
            if (changes.length > 0) {
                const groups = { en_destino: 0, finalizado: 0, postventa: 0, historico: 0 };
                changes.forEach(c => { if (groups[c.newStage] !== undefined) groups[c.newStage]++; });
                const labels = { en_destino: 'en destino', finalizado: 'finalizado', postventa: 'postventa', historico: 'historico' };
                const parts = Object.entries(groups).filter(([, n]) => n > 0).map(([s, n]) => n + ' ' + labels[s]);
                toast(changes.length + ' viaje' + (changes.length > 1 ? 's' : '') + ' actualizado' + (changes.length > 1 ? 's' : '') + ': ' + parts.join(', '), 'success', { persistent: true });
            }
        } catch {
            toast('Error en transiciones automaticas', 'error');
        }

        // Auto-create client dashboards for confirmed leads without one
        try { await window.autoCreateDashboards(); } catch {}
    }

    applyTheme(store.currentTheme);
    populateSelects();
    populateMonthFilter();
    populateEmpYearFilters();
    populateEmpCompanyDropdowns();
    renderAll();
    setupDragDrop();
    setupUploadZone();
    setupPDFUploadZone();
    updateFormBadge();
    updateUserDisplay();

    // Auto-create leads from pending form submissions (after full init)
    await processNewSubmissions();

    // Poll for new submissions every 30s (fallback if Realtime drops)
    setInterval(pollNewSubmissions, 30000);

    // Inicializar zoom con valores guardados
    const savedNavZoom = store.settings.navZoom || 1.0;
    const savedTopZoom = store.settings.topZoom || 1.0;
    const savedLeadsZoom = store.settings.leadsZoom || store.settings.zoomDefault || 1.0;
    const navSliderEl = document.getElementById('navZoomSlider');
    const topSliderEl = document.getElementById('topZoomSlider');
    const leadsSliderEl = document.getElementById('leadsZoomSlider');
    if (navSliderEl) navSliderEl.value = savedNavZoom;
    if (topSliderEl) topSliderEl.value = savedTopZoom;
    if (leadsSliderEl) leadsSliderEl.value = savedLeadsZoom;
    setNavZoom(savedNavZoom);
    setTopZoom(savedTopZoom);
    setLeadsZoom(savedLeadsZoom);
    // Apply UI font scale from settings
    applyUIFontScale(store.settings.uiFontScale || 1.0);

    // Load unmatched WhatsApp messages + show badge
    window.loadUnmatchedOnInit?.();
}

async function handleLogout() {
    if (!confirm('¿Cerrar sesión?')) return;
    await supabaseDB.signOut();
    store.leads = []; store.historico = []; store.clients = {}; store.tareas = [];
    document.getElementById('app').classList.remove('active');
    document.body.classList.remove('logged-in');
    document.getElementById('loginScreen').style.display = '';
}

async function checkExistingSession() {
    if (supabaseDB.isConnected()) {
        const session = await supabaseDB.getSession();
        if (session) {
            document.getElementById('loginScreen').style.display = 'none';
            document.getElementById('app').classList.add('active');
            document.body.classList.add('logged-in');
            await initApp();
            window.scrollTo(0, 0);
            document.querySelector('.main')?.scrollTo(0, 0);
        }
    }
}


// ========== WINDOW BRIDGE ==========
Object.assign(window, {
    initApp,
    handleLogout,
    checkExistingSession,
    _setupLoginHandler,
});
